import React, { useMemo } from 'react'
import { Row } from '../components/layout'
import styled from 'styled-components'

interface Props {
  current: number
  count: number
}

export default function Indicator({ current, count }: Props) {
  const source = useMemo(
    () =>
      Array<number>(count)
        .fill(0)
        .map((_, i) => i),
    [count]
  )

  return (
    <Row gutter={8}>
      {source.map(v => (
        <Item key={v} className={v === current && 'active'} />
      ))}
    </Row>
  )
}

const Item = styled.div`
  width: 12px;
  height: 12px;
  box-sizing: border-box;
  border-radius: 50%;
  border: 1px solid #c4c4c4;

  &.active {
    background: #c4c4c4;
  }
`
